<template lang="html">
  <div v-if="showPop">
    <div class="help-error-pop-container">
      <div class="pop-main"  v-if="helpErrorCode === 'toDay_helped_B' || helpErrorCode === 'toDay_helped_Others'">
        <div class="head" v-html="popData.toDay_helped_B.head">
        </div>
        <div class="other" v-html="popData.toDay_helped_B.content">
        </div>
        <button clstag="jr|keycount|sqqxl_20181016|17" @click="goMainVenue"><span v-html="popData.toDay_helped_B.btnTxt"></span></button>
      </div>
      <div class="pop-main"  v-else-if="helpErrorCode === 'act_ex'">
        <div class="head" v-html="popData.act_ex.head">
        </div>
        <div class="other"  v-html="popData.act_ex.content">
        </div>
        <button clstag="jr|keycount|sqqxl_20181016|11" @click="goMainVenue"><span v-html="popData.act_ex.btnTxt"></span></button>
      </div>
      <div class="pop-main friend"  v-else-if="helpErrorCode === 'no_can_help_self'">
        <div class="head" v-html="popData.no_can_help_self.head">
        </div>
        <div class="other"  v-html="popData.no_can_help_self.content">
        </div>
        <button clstag="jr|keycount|sqqxl_20181016|20" @click="goDownLoadMainPage"><span  v-html="popData.no_can_help_self.btnTxt"></span></button>
      </div>
      <div class="pop-main"  v-else-if="helpErrorCode === 'receive-error-fe'">
        <div class="head" v-html="popData.receive_error_fe.head">
        </div>
        <div class="other" v-html="popData.receive_error_fe.content">
        </div>
        <button clstag="jr|keycount|sqqxl_20181016|22" @click="goIndexPage" ><span  v-html="popData.receive_error_fe.btnTxt"></span></button>
      </div>
      <div class="pop-main"  v-else-if="helpErrorCode === 'picked_rdId'">
        <div class="head" v-html="popData.picked_rdId.head">
        </div>
        <div class="other" v-html="popData.picked_rdId.content">
        </div>
        <button clstag="jr|keycount|sqqxl_20181016|19" @click="goMainVenue" ><span v-html="popData.picked_rdId.btnTxt"></span></button>
      </div>
      <div class="pop-main"  v-else>
        <div class="head" v-html="popData.__else.head">
        </div>
        <div class="other" v-html="popData.__else.content">
        </div>
        <button clstag="jr|keycount|sqqxl_20181016|12" @click="goMainVenue"><span v-html="popData.__else.btnTxt"></span></button>
      </div>
      <img src="./images/close.png" class="close-btn" @click="goIndexPage" v-if="helpErrorCode === 'receive-error-fe'"/>
      <img src="./images/close.png" class="close-btn" @click="closePop" v-else/>
    </div>
    <div class="shadow"></div>
  </div>
</template>

<script>
import { 
  goMainVenue,
  goDownLoadMainPage,
  goIndexPage
} from "@/public/util.js";

export default {
  props:["showPop","helpErrorCode"],
  data () {
    return {
      popData:data_source_100001051.helpErrorPop
    }
  },
  methods: {
    closePop(){
      // this.showPop = false;
      this.$emit("closePop","HelpErrorPop");
    },
    goMainVenue(){
      goMainVenue();
    },
    goDownLoadMainPage(){
      goDownLoadMainPage();
    },
    goIndexPage(){
      goIndexPage();
    }
  }
}
</script>

<style lang="scss" scoped>
.help-error-pop-container{
  position: fixed;
  width: 540px;
  height: 690px;
  left: 50%;
  top: 50%;
  margin-left: -270px;
  margin-top: -330px;
  z-index: 9999;
  .pop-main{
    width: 540px;
    height: 570px;
    background: url(./images/bg_new.png) center no-repeat;
    background-size: 100%;
    margin: 0 auto;
    color: #fff;
    text-align: center;
    .head{
      font-size:56px;
      font-weight:bold;
      color:rgba(255,255,255,1);
      line-height:68px;
      text-shadow:0px 8px 79px rgba(9,0,59,0.64);
      padding-top: 79px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .other{
      width: 396px;
      font-size:36px;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:60px;
      margin: 0 auto 50px;
      padding-top: 55px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    &.friend{
      .other{
        margin: 20px auto 40px;
      }
    }
    button{
      width: 450px;
      height: 100px;
      text-align: center;
      background: url(./images/btn_new.png) center no-repeat;
      background-size: 100%;
      box-shadow: 0 11px 27px rgba(0,0,0,0.43);
      display: block;
      margin:0 auto;
      border:none;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      &:focus{
        border:none;
      }
      span{
        background-image: -webkit-gradient(linear, 0 0, right 0, from(rgba(172, 25, 22, 1)), to(rgba(107, 13, 12, 1)));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 36px;
        line-height: 100px;
        font-weight: bold;
      }
    }
  }
  .close-btn{
    width: 60px;
    height: 60px;
    display: block;
    margin: 60px auto 0;
  }
}

.shadow{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9998;
}
</style>



// WEBPACK FOOTER //
// src/components/HelpErrorPop/index.vue